import {React, Component, Container, _} from 'utils';
import {FairStore} from 'model';
import {ajaxLoader} from 'resources';
import './loading.less'

class Loading extends Component {

	static getStores()
	{
		return [FairStore];
	}

	static calculateState()
	{
		let fairStoreLoader = FairStore.getState().loaderUrl;

		return {
			loaderUrl: fairStoreLoader ? fairStoreLoader : ajaxLoader,
		}
	}

	handleLoaderImageError = () => {
		this.setState({loaderUrl: ajaxLoader});
	};

	render()
	{
		let {visible, description} = this.props;

		let {loaderUrl} = this.state;

		if (visible)
		{
			let view = description ? <div className="description">{description}</div> : null;

			return (
				<div className="loading-box">
					<div className="card">
						<div className="card-body">
							<img src={loaderUrl} alt={_('Loading')} onError={this.handleLoaderImageError}/>
							{view}
						</div>
					</div>
				</div>
			);
		}
		else
		{
			return null;
		}
	}
}

export default Container.create(Loading);


// WEBPACK FOOTER //
// ./src/modules/components/loading.js